const posted = () => ({
  active: 1,
  idakun_keuangan_edc: "",
  nama_mesin_edc: "",
  idoutlet: "",
  idakun_keuangan_settlement: 0,
  idprovider: "",
  persen_sesama_edc: 0,
  persen_berbeda_provider: 0,
  persen_kartu_kredit: 0,
});

export default posted;